module.exports = __webpack_public_path__ + "static/media/cryptocurrency.6c40feca.svg";